import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=88bd2088&scoped=true"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"
import style0 from "./MapLegend.vue?vue&type=style&index=0&id=88bd2088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bd2088",
  null
  
)

export default component.exports